module.exports = __webpack_public_path__ + "static/media/1_A1_05.d2c4e471.png";